<script setup>
import { ref, watch } from 'vue'
import * as echarts from 'echarts'
import { useStore } from 'vuex'

const props = defineProps({
  // 传入的表格数据
  yData: {
    type: Array,
    default: () => []
  },
  xData: {
    type: Number,
    default: 1
  }
})
const store = useStore()
//柱状图
const chartRef = ref(null)
// 监听数据变化
watch(
  () => [props.yData, props.xData],
  ([newYData, newXData]) => {
    if (chartRef.value) {
        const maxData = Math.max(...newYData)
        let yAxisMax = maxData * 1 === 0 ? 1 : maxData
        const splitCount = newYData.length
        const splitColors = Array(splitCount).fill('#E1E1E1')
        // 设置分割count
        const lineCount = Math.ceil(yAxisMax / splitCount) 
        yAxisMax = splitCount * lineCount // 向上取整
        // console.log('yAxisMax', yAxisMax, 'splitCount', splitCount, 'lineCount', lineCount)
        splitColors[splitCount] = 'transparent' // 最后一条变透明 
        if (chartRef.value) {
        const chart = echarts.init(chartRef.value)
        chart.setOption({
            title: {
              text: `收益金额：${store.state.publicConfig.title}`,
              left: '50px',
              top: '10px',
              textStyle: {
                fontSize: 10,
                fontWeight: 'normal'
              }
            },
            tooltip: {
              trigger: 'axis',
              extraCssText: 'z-index:99;'
            },
            grid: {
              left: '5px',
              right: '5px',
              bottom: '10%',
              top: '20%',
              containLabel: true
            },
            xAxis: {
            type: 'category',
            data: newXData,
            axisLabel: {
              color: '#999',
              textStyle: {
                fontSize: 10,
                fontWeight: 'normal'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#eee'
              }
            }
            },
            yAxis: {
            type: 'value',
            min: 0,
            max: yAxisMax,
            splitNumber: splitCount,
            axisLabel: {
              formatter: function (value) {
                return value === yAxisMax ? '' : value
              },
              color: '#00000099',
              textStyle: {
                fontSize: 10,
                fontWeight: 'normal'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#eee'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: splitColors
              }
            }
            },
            series: [
            {
              type: 'bar',
              data: newYData,
              itemStyle: {
                color: '#cceeff'
              },
              barWidth: '80%'
            }
            ]
        })
        }
    }
  },
  { immediate: true }
)
</script>
 
<template>
  <div class="yueBao-chart-main" ref="chartRef" style="width: 100%; height: 270px;"></div>
</template>

<style scoped lang="less">

</style>
 